/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface UpdateProductBankItemDto
 */
export interface UpdateProductBankItemDto {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBankItemDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBankItemDto
     */
    brand?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBankItemDto
     */
    manufacturer?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBankItemDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBankItemDto
     */
    upc?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBankItemDto
     */
    ndc?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBankItemDto
     */
    drugType?: UpdateProductBankItemDtoDrugTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBankItemDto
     */
    dosageForm?: UpdateProductBankItemDtoDosageFormEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBankItemDto
     */
    strength?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateProductBankItemDto
     */
    activeIngredients?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBankItemDto
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductBankItemDto
     */
    subCategory?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateProductBankItemDto
     */
    tags?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateProductBankItemDto
     */
    images?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductBankItemDto
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductBankItemDto
     */
    isVerified?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateProductBankItemDtoDrugTypeEnum {
    OTC = 'OTC',
    RX = 'RX',
    SUPPLEMENT = 'SUPPLEMENT',
    GENERAL = 'GENERAL'
}
/**
    * @export
    * @enum {string}
    */
export enum UpdateProductBankItemDtoDosageFormEnum {
    TABLET = 'TABLET',
    CAPSULE = 'CAPSULE',
    LIQUID = 'LIQUID',
    CREAM = 'CREAM',
    GEL = 'GEL',
    SPRAY = 'SPRAY',
    PATCH = 'PATCH',
    DROPS = 'DROPS',
    POWDER = 'POWDER',
    CHEWABLE = 'CHEWABLE',
    OTHER = 'OTHER'
}

